const Issue = (app) => {
  app.post("/issues/report", async ({ req, res, locals, api, flash }) => {
    await api("issue", { method: "POST", body: req.body });
    flash("success", "Successfully reported");
    res.refreshWith({ modal: "" }, { url: "back" });
  });
};

export default Issue;
